import {
  generateTableHtml,
  tableHtmlWrapper
} from '@/utils/generate-html/table'
import { setColumnConfig } from './generate-materiel-html'

import { strToThousands } from '@/utils/utils'
import nzhcn from 'nzh/cn'

/**
 * 获取成交PDF
 */
export function generateResultHtml({
  pdfData = {},
  pdfTitle = '',
  isDollar = false
}) {
  const fontWeight = 'font-weight: bold;'
  const awardList = pdfData.awardList || []

  // 项目成交单位概要信息
  const sumTableHeader = [[{ content: '采购信息表', colspan: 2 }]]
  const awardListObj = {}
  awardList.forEach(el => {
    const offerTotalPrice = el.offer?.offerTotalPrice
      ? Number(el.offer?.offerTotalPrice)
      : 0
    if (!awardListObj[el.supplierId]) {
      awardListObj[el.supplierId] = {}
      awardListObj[el.supplierId].supplierName = el.supplierName
      awardListObj[el.supplierId].offerTotalPrice = offerTotalPrice
    } else {
      awardListObj[el.supplierId].offerTotalPrice =
        (Number(awardListObj[el.supplierId].offerTotalPrice) * 100 +
          offerTotalPrice * 100) /
        100
    }
  })
  const sumTableBody = Object.keys(awardListObj).map((supplierId, index) => {
    return [
      // 成交单位名称
      { content: awardListObj[supplierId].supplierName || '-' },
      // 成交金额（元）
      {
        content: [
          awardListObj[supplierId].offerTotalPrice
            ? strToThousands(awardListObj[supplierId].offerTotalPrice)
            : '-',
          isDollar
            ? undefined
            : {
              content: `大写：${nzhcn.toMoney(
                parseFloat(awardListObj[supplierId].offerTotalPrice || '0'),
                { outSymbol: false }
              )}`,
              style: 'color: #ff4d4f'
            }
        ].filter(value => value)
      }
    ]
  })
  sumTableBody.unshift([
    { content: '成交单位名称', width: '200px' },
    {
      content: `成交金额（${isDollar ? '美元' : '元'}）`,
      width: '200px'
    }
  ])
  const resultSumHtml = generateTableHtml({
    pdfTitle: pdfTitle,
    describeInfoTop: [
      [
        { label: '询比单名称', content: `${pdfData.orderName}询比单` },
        {
          label: `项目估算（${isDollar ? '万美元' : '万元'}）`,
          content: pdfData.budgetAmount
        },
        {
          label: '项目负责人',
          content: `${pdfData.releaserEmpName} ${pdfData.releaserMobile}`
        }
      ],
      [{ label: '', content: '项目成交单位概要信息', style: fontWeight }]
    ],
    tableHead: { fixedPrev: sumTableHeader },
    tableData: sumTableBody,
    needHtmlWrapper: false,
    noFormat: true
  })

  // 项目成交单位详细信息
  const { unitPriceConfig, nameConfig, unitConfig } = setColumnConfig(
    pdfData.itemSchemaList || []
  )
  const detailTableHeader = [[{ content: '采购信息表', colspan: 6 }]]
  const detailTableBody = awardList.map((item, index) => {
    const materiel = item.materiel || {}
    const offer = item.offer || {}
    return [
      // 品目名称
      { content: materiel[nameConfig.defineCode] },
      // 预算单价
      {
        content: materiel[unitPriceConfig.defineCode]
          ? strToThousands(materiel[unitPriceConfig.defineCode])
          : '-'
      },
      // 成交数量/单位
      { content: `${item.awardNum}/${materiel[unitConfig.defineCode]}` },
      // 成交单位名称
      { content: item.supplierName || '-' },
      // 成交单价
      {
        content: [
          offer.offerPrice ? strToThousands(offer.offerPrice) : '-',
          isDollar
            ? undefined
            : {
              content: `大写：${nzhcn.toMoney(
                parseFloat(offer.offerPrice || '0'),
                { outSymbol: false }
              )}`,
              style: 'color: #ff4d4f'
            }
        ].filter(value => value)
      },
      // 成交总价
      {
        content: [
          offer.offerTotalPrice ? strToThousands(offer.offerTotalPrice) : '-',
          isDollar
            ? undefined
            : {
              content: `大写：${nzhcn.toMoney(
                parseFloat(offer.totalPrice || '0'),
                { outSymbol: false }
              )}`,
              style: 'color: #ff4d4f'
            }
        ].filter(value => value)
      }
    ]
  })
  detailTableHeader.unshift([
    { content: '品目名称', width: '200px' },
    {
      content: `预算单价（${isDollar ? '美元' : '元'}）`,
      width: '200px'
    },
    { content: '成交数量/计量单位', width: '200px' },
    { content: '成交单位名称', width: '200px' },
    {
      content: `成交单价（${isDollar ? '美元' : '元'}）`,
      width: '200px'
    },
    {
      content: `成交总价（${isDollar ? '美元' : '元'}）`,
      width: '200px'
    }
  ])
  const resultDetailHtml = generateTableHtml({
    pdfTitle: pdfTitle,
    describeInfoTop: [
      [{ label: '', content: '项目成交单位详细信息', style: fontWeight }]
    ],
    tableHead: { fixedPrev: detailTableHeader },
    tableData: detailTableBody,
    needHtmlWrapper: false,
    noFormat: true
  })

  const tableHtml = tableHtmlWrapper(resultSumHtml + resultDetailHtml, pdfTitle)
  return tableHtml
}
